import { render, staticRenderFns } from "./ycdl.vue?vue&type=template&id=38090754&scoped=true"
import script from "./ycdl.vue?vue&type=script&lang=js"
export * from "./ycdl.vue?vue&type=script&lang=js"
import style0 from "./ycdl.vue?vue&type=style&index=0&id=38090754&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38090754",
  null
  
)

export default component.exports